import React from "react";
import Joi from "joi-browser";
import { Form } from "./form.jsx";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";

import {
  getValidateProcessName,
  getD4Result,
  getPriority,
  loadImage,
} from "../../services/uiService.jsx";
import ChecksPopupForm from "./checksPopupForm.jsx";
import { loadState, saveState } from "../../services/browserSessionID.jsx";
import DynamicForm from "../fields/DynamicForm.jsx";
import SideMenuContext from "../../context/sideMenuContext.js";
import ModalComponent from "../modal/modalComponent.jsx";
import Button from "react-bootstrap/esm/Button.js";
import {
  clearAllErrors,
  setErrorMessage,
  setIsSuccessUpdate,
  setSuccessMessage,
} from "../../redux/slices/landSearchSlice.js";

class SearchTamarForm extends Form {
  static contextType = SideMenuContext;
  _isMounted = false;
  updateTimeout = null;

  state = {
    data: {
      Project_No: this.props.project_no,
      Project_Name: this.props.project_name,
      D4IsDone: false,
      DWG: this.props.dwg,
      FullRun: true,
    },
    paramsData: [
      { FieldName: "Project_No", FieldType: "String" },
      { FieldName: "Project_Name", FieldType: "String" },
      { FieldName: "DWG", FieldType: "String" },
      { FieldName: "FullRun", FieldType: "Boolean" },
    ],
    errors: {},
    activeTabData: null,
    selectedFile: null,
    uploadProgress: 0,
    isPopupOpen: false,
    isFirstLoad: true,
    browserSessionID: loadState("sessionID", uuidv4()), // Load or initialize sessionID
    isNotD3: true,
    lastObj: {},
    rb12s: ["D2_D3_ALL", "D2_ALL"],
    isFileSelectedForstartRun: false,
    fileIsExists: false,
    processNoIsNotFound: false,
    overRideFile: false,
    somethingWentToWrong: false,
    noCheckChosen: false,
    loadingFile: false,
    errorValidateProcessMessage: "",
    D4ResultMessage: "",
    formFields: [
      {
        id: 1,
        name: `מספר פרויקט`,
        label: `מספר פרויקט`,
        type: `text`,
        placeholder: ``,
        readonly: true,
        value: ``,
      },
      {
        id: 2,
        name: `שם פרויקט`,
        label: `שם פרויקט`,
        type: `text`,
        placeholder: ``,
        readonly: true,
        value: ``,
      },
      // {
      //   id: 3,
      //   name: `מספרתמ"ר/מספרתמ"רראשונה`,
      //   label: `מספרתמ"ר/מספרתמ"רראשונה`,
      //   type: `text`,
      //   placeholder: ``,
      //   readonly: true,
      //   value: ``,
      // },
    ],
  };

  schema = {
    Project_No: Joi.string().allow("").default("").label("Project No "),
    Project_Name: Joi.string().allow("").default(" ").label("Project Name "),
    DWG: Joi.string().allow("").default(" ").label("DWG "),
    FullRun: Joi.boolean().default(1).label("Full Run "),
  };

  handleUnload(e) {
    // User actually leaves the page
    alert("Yes excalt ut work");
  }

  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = "";

    // No need to set returnValue as some browsers might use it for their own prompts
    const confirmed = window.confirm("Are You Sure?");

    if (confirmed) {
      this.sendSessionEndRequest()
        .then(() => console.log("Session end data sent successfully"))
        .catch((error) =>
          console.error("Failed to send session end data:", error)
        );
    }
  };

  doSubmit = () => {};

  sendSessionEndRequest = async () => {
    const { browserSessionID } = this.state;
    try {
      // Show loading indicator if needed
      this.setState({ isSendingSessionData: true });
      const url = `${
        this.props.generalEndPoint
      }/cancelque?sessionID=${encodeURIComponent(browserSessionID)}`;
      await axios.post(url);
    } catch (error) {
      console.error("Failed to send session end data:", error);
    } finally {
      // Hide loading indicator if needed
      this.setState({ isSendingSessionData: false });
    }
  };

  togglePopup = () => {
    this.setState((prevState) => ({
      isPopupOpen: !prevState.isPopupOpen,
    }));
  };

  processOverrideOrNot = (payload) => {
    if (payload) {
      this.setState({ fileIsExists: false, overRideFile: true });
      this.handleStartRun();
    } else {
      this.props.setExistFileGUID("");
      this.setState({ fileIsExists: false, overRideFile: false });
      this.props.isDataInProcess(false);
    }
  };

  getFileIsExistOrNot = () => {
    const { browserSessionID } = this.state;
    let { extraParams } = this.props;

    if (!this.state.selectedFile) {
      this.setState({ isFileSelectedForstartRun: true });
      return;
    }

    this.setState({ loadingFile: true });
    this.props.isDataInProcess(true);

    const userDataString = sessionStorage.getItem("userData");
    let displayName = "";

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      displayName = userData.user.displayName; 
    }
    
    const formData = new FormData();

    formData.append("dwgFile", this.state.selectedFile);
    formData.append("checkNumber", "process_name_validation");
    formData.append("checkType", "D2");
    formData.append("sessionID", browserSessionID);
    formData.append("ProjectID", extraParams?.projectID);
    formData.append("Username", displayName);

    getValidateProcessName(this.props.generalEndPoint, formData)
      .then((result) => {
        this.setState({ loadingFile: false });
        if (
          (result?.["ProcessName"] === null ||
            result?.["ProcessName"] === "" ||
            result?.["ProcessName"]?.length === 0) &&
          result?.["Error"]?.toLocaleLowerCase() ===
            "No ProcessName value found in the ellipse block".toLocaleLowerCase()
        ) {
          this.setState({
            errorValidateProcessMessage:
              "מספר התוכנית (מספר האליפסה) חסר בתוכנית. המערכת לא תמשיך בפעולה",
          });
          this.setState({ somethingWentToWrong: true });
        } else {
          // if (result?.["ProcessName"] === "") {
          //   this.setState({
          //     processNoIsNotFound: true,
          //     fileIsExists: false,
          //   });
          // } else {
          // }
          if (
            result?.["GUID"] !== null &&
            result?.["GUID"]?.length > 0 &&
            result?.["ProcessName"] !== "" &&
            result?.["ProcessName"]?.length > 0
          ) {
            this.setState({
              fileIsExists: true,
              processNoIsNotFound: false,
            });
            this.props.setExistFileGUID(result?.["GUID"]);
          } else if (
            result?.["ProcessName"] !== null &&
            result?.["ProcessName"]?.length > 0
          ) {
            this.setState({
              fileIsExists: false,
              processNoIsNotFound: false,
            });
            this.props.setExistFileGUID("");
            this.handleStartRun();
          } else {
            this.setState({
              errorValidateProcessMessage:
                "התרחשה שגיאה, אנא נסה שוב מאוחר יותר",
            });
            this.setState({ somethingWentToWrong: true });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  onChangeValue = (event) => {
    this.props.setSelectedRuns(event.target.value);
    if (!["ChosenRuns", "on"]?.includes(event.target.value)) {
      this.props.handleOnChange({
        selectedD2Checks: [],
        selectedD3Checks: [],
      });
    }
  };

  handleFileChange = (event) => {
    this.props.setFileName(
      event.target.files[0]?.["name"]?.replace(".dwg", "")
    );
    this.setState({ selectedFile: event.target.files[0] });
  };

  handleStartRun = async () => {
    await this.handleUploadFile();
  };

  handleStartRunD3 = async (checkD4) => {
    await this.handleUploadFileD3(checkD4);
  };

  handleUploadFile = async (checkD4 = false) => {
    let { selectedFile, overRideFile } = this.state;

    let {
      D2_checksList,
      D3_checksList,
      selectedRuns,
      selectedD2Checks,
      selectedD3Checks,
      extraParams,
    } = this.props;
    console.log("extraParams ", extraParams);
    if (!extraParams?.projectID) {
      alert("ProjectID is Undefined");
      return;
    }

    if (!extraParams?.projectID) {
      alert("ProjectID is Undefined");
      return;
    }

    const userDataString = sessionStorage.getItem("userData");
    let displayName = "";

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      displayName = userData.user.displayName; 
    }

    const formData = new FormData();
    // formData.append("ProjectID", this.state.activeTabData?.find(res=>res.id === "ProjectNumber")?.value);
    formData.append("ProjectID", extraParams?.projectID);

    if (!selectedFile) {
      console.error("No file selected.");
      this.props.isDataInProcess(false);
      return;
    }

    if (checkD4) {
      const { existFileGUID } = this.props;
      if (overRideFile) {
        formData.append("checkD4", "D4");
        formData.append("D4GUID", existFileGUID);
      } else {
        formData.append("checkD4", "D4"); // Append checkD4 field
      }
    } else if (checkD4 === "D3") {
      const priority = await getPriority(this.props.generalEndPoint);

      D3_checksList?.forEach((item, index) => {
        formData.append(
          `checkLists.D3_checksList[${index}].CheckNo`,
          item.checkNo
        );
        formData.append(
          `checkLists.D3_checksList[${index}].CheckSeverity`,
          item.severity
        );
        formData.append(
          `checkLists.D3_checksList[${index}].Priority`,
          priority + index
        );
        formData.append("isRB3", false);
      });
    } else {
      const priority = await getPriority(this.props.generalEndPoint);

      if (selectedRuns === "D2_D3_ALL") {
        D2_checksList?.forEach((item, index) => {
          formData.append(
            `checkLists.D2_checksList[${index}].CheckNo`,
            item.checkNo
          );
          formData.append(
            `checkLists.D2_checksList[${index}].CheckSeverity`,
            item.severity
          );
          formData.append(
            `checkLists.D2_checksList[${index}].Priority`,
            priority + index
          );
        });
        this.setState({
          isNotD3: true,
        });
        formData.append("isRB3", false);
      } else if (selectedRuns === "D2_ALL") {
        D2_checksList?.forEach((item, index) => {
          formData.append(
            `checkLists.D2_checksList[${index}].CheckNo`,
            item.checkNo
          );
          formData.append(
            `checkLists.D2_checksList[${index}].CheckSeverity`,
            item.severity
          );
          formData.append(
            `checkLists.D2_checksList[${index}].Priority`,
            priority + index
          );
          formData.append("isRB3", false);
        });
      } else if (selectedRuns === "ChosenRuns" || selectedRuns === "on") {
        selectedD2Checks.forEach((item, index) => {
          formData.append(
            `checkLists.D2_checksList[${index}].CheckNo`,
            item?.key
          );
          formData.append(
            `checkLists.D2_checksList[${index}].CheckSeverity`,
            item?.severity
          );
          formData.append(
            `checkLists.D2_checksList[${index}].Priority`,
            priority + index
          );
        });

        selectedD3Checks.forEach((item, index) => {
          formData.append(
            `checkLists.D3_checksList[${index}].CheckNo`,
            item?.key
          );
          formData.append(
            `checkLists.D3_checksList[${index}].CheckSeverity`,
            item?.severity
          );
          formData.append(
            `checkLists.D3_checksList[${index}].Priority`,
            // item?.priority
            priority + (selectedD2Checks?.length || 0) + index
          );
        });

        formData.append("isRB3", true);

        //Check if some checks were chosen for RB3
        if (!selectedD2Checks.length && !selectedD3Checks.length) {
          this.setState({ noCheckChosen: true });
        }
      }
    }

    if (
      (selectedRuns === "ChosenRuns" || selectedRuns === "on") &&
      !selectedD3Checks?.length &&
      !selectedD2Checks?.length
    )
      return;
    formData.append("file", selectedFile);
    formData.append(`checkLists.SessionID`, this.state.browserSessionID);
    formData.append("Username", displayName);

    if (checkD4) {
      this.props.isDataInProcess(true);
      this.props.setLoading(true);

      const response = await axios.post(
        this.props.generalEndPoint + "/StartRun",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 1200000,
        }
      );
      this.props.setExistFileGUID("");

      let result = null;
      while (result?.status !== "Processed") {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        result = await getD4Result(
          this.props.generalEndPoint,
          this.state.browserSessionID
        );
      }
      this.setState({ D4IsDone: true });
      this.props.setRunningD4(false);
      if (result?.result === "No Errors") {
        this.setState({ D4ResultMessage: 'התמ"ר נטענה בהצלחה' });
      } else if (result?.result === "Rebuild Failure") {
        this.setState({
          D4ResultMessage:
            "תהליך הפצת שכבות המידע נכשל. מומלץ להריץ מחדש או לבצע הפצת שכבות שלא מתוך המערכת",
        });
      } else {
        this.setState({ D4ResultMessage: 'טעינת התמ"ר נכשלה' });
      }
      this.props.isDataInProcess(false);
    } else {
      try {
        this.props.isDataInProcess(true);
        this.props.setLoading(true);
        const response = await axios.post(
          this.props.generalEndPoint + "/StartRun",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 1200000,
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              this.setState({ uploadProgress: percentCompleted });
              this.props.handleUploadProgress(percentCompleted);
            },
          }
        );

        if (response?.status === 200) {
          this.setState({ uploadProgress: 100 }); // Ensure progress bar shows 100%

          this.props.handleUploadProgress(100);
          this.props.addInFirstObj();
          this.props.setLoading(false);
          checkD4 && this.props.setExistFileGUID("");
        }
      } catch (error) {
        console.error("Error uploading data:", error);
        this.setState({ uploadProgress: 0 }); // Reset progress bar on error
        this.props.handleUploadProgress(0);
        this.props.isDataInProcess(false);
        this.props.setLoading(false);
      }
    }
  };

  handleUploadFileD3 = async (checkD4 = false) => {
    let { selectedFile, overRideFile } = this.state;
    const { D3_checksList, existFileGUID, extraParams } = this.props;

    const userDataString = sessionStorage.getItem("userData");
    let displayName = "";

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      displayName = userData.user.displayName; 
    }

    const formData = new FormData();

    if (!selectedFile) {
      console.error("No file selected.");
      this.props.isDataInProcess(false);
      return;
    }
    formData.append("ProjectID", extraParams?.projectID);

    if (checkD4) {
      formData.append("checkD4", "D4");
      formData.append("checkNumber", "import_tmr");
      if (overRideFile) {
        formData.append("D4GUID", existFileGUID);
      }
    } else {
      const priority = await getPriority(this.props.generalEndPoint);

      D3_checksList?.forEach((item, index) => {
        formData.append(
          `checkLists.D3_checksList[${index}].CheckNo`,
          item.checkNo
        );
        formData.append(
          `checkLists.D3_checksList[${index}].CheckSeverity`,
          item.severity
        );
        formData.append(
          `checkLists.D3_checksList[${index}].Priority`,
          priority + index
        );
      });
    }

    formData.append("file", selectedFile);
    formData.append(`checkLists.SessionID`, this.state.browserSessionID);
    formData.append("Username", displayName);

    try {
      this.props.isDataInProcess(true);
      this.props.setLoading(true);

      const response = await axios.post(
        this.props.generalEndPoint + "/StartRun",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 1200000,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            this.setState({ uploadProgress: percentCompleted });
            this.props.handleUploadProgress(percentCompleted);
          },
        }
      );

      if (response?.status === 200) {
        this.setState({ uploadProgress: 100 }); // Ensure progress bar shows 100%
        this.props.handleUploadProgress(100);
        this.props.setLoading(false);
        this.props.addInFirstObj();
        checkD4 && this.props.setExistFileGUID("");
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      this.props.handleUploadProgress(0);
      this.setState({ uploadProgress: 0 }); // Reset progress bar on error
      this.props.isDataInProcess(false);
      this.props.setLoading(false);
    }
  };

  handleSelectedCheckboxes = (selectedCheckboxes) => {
    this.setState({ isFirstLoad: false });
    const { D2_checksList, D3_checksList, D3_cmp } = this.props;

    const selectedD2Checks = Object.keys(selectedCheckboxes.Tab1)
      .filter((key) => selectedCheckboxes.Tab1[key])
      .map((key) => {
        const severityObjD2 = D2_checksList?.find(
          (checkList) => checkList?.checkNo === key
        );

        return {
          key,
          ...(severityObjD2["severity"] &&
            key && {
              severity: severityObjD2["severity"],
              priority: selectedCheckboxes.Tab1[key]["priority"],
            }),
          value: selectedCheckboxes.Tab1[key],
        };
      });

    const selectedD3AdvancedChecks = Object.keys(selectedCheckboxes.Tab2)
      .filter((key) => selectedCheckboxes.Tab2[key])
      .map((key) => {
        const severityObjD3 = D3_checksList?.find(
          (checkList) => checkList?.checkNo === key
        );
        return {
          key,
          value: selectedCheckboxes.Tab2[key],
          ...(severityObjD3["severity"] &&
            key && {
              severity: severityObjD3["severity"],
              priority: selectedCheckboxes.Tab2[key]["priority"],
            }),
        };
      });

    const selectedD3CmpChecks = Object.keys(selectedCheckboxes.Tab3)
      .filter((key) => selectedCheckboxes.Tab3[key])
      .map((key) => {
        const severityObjD3Cmp = D3_cmp?.find(
          (checkList) => checkList?.checkNo === key
        );
        return {
          key,
          value: selectedCheckboxes.Tab3[key],
          ...(severityObjD3Cmp["severity"] &&
            key && {
              severity: severityObjD3Cmp["severity"],
              priority: selectedCheckboxes.Tab3[key]["priority"],
            }),
        };
      });
    this.props.handleOnChange({
      selectedD2Checks,
      selectedD3Checks: selectedD3AdvancedChecks.concat(selectedD3CmpChecks),
    });
  };

  componentDidMount() {
    this._isMounted = true;

    window.addEventListener("beforeunload", this.handleBeforeUnload);
    window.addEventListener("unload", () => {
      console.log("clicked cancel");
    });

    saveState("sessionID", this.state.browserSessionID); // Save the sessionID to sessionStorage
    window.addEventListener("unload", this.handleUnload);

    document.addEventListener("visibilitychange", function (event) {
      if (document.visibilityState === "hidden") {
      }
    });
  }

  componentDidUpdate(prevProps) {
    const lastObj = prevProps.processes[0];

    const { isNotD3 } = this.state;
    const { selectedRuns } = this.props;

    if (
      isNotD3 &&
      lastObj &&
      lastObj?.["dataList"]?.length === lastObj?.["completedList"].length &&
      lastObj?.["checkType"] === "D2" &&
      lastObj?.["selectedRuns"] === "D2_D3_ALL" &&
      selectedRuns === "D2_D3_ALL" &&
      lastObj?.["dataList"][0]?.checkNumber !== "validateProcessName"
    ) {
      this.setState({
        isNotD3: false,
        lastObj: lastObj,
      });

      this.handleStartRunD3();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    window.addEventListener("beforeunload", function (e) {
      e.preventDefault();
      e.returnValue = "";
    });
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    window.removeEventListener("unload", this.handleUnload);
  }

  render() {
    const { projectData, loading, error } = this.props;
    const {
      errorMessage,
      selectedFile,
      isPopupOpen,
      rb12s,
      loadingFile,
      errorValidateProcessMessage,
      D4ResultMessage,
    } = this.state;
    const { selectedRuns } = this.props;

    const { D2_checksList, D3_advanced, D3_cmp } = this.props;
    const loadingIcon = loadImage("loading_continuous.gif");

    return (
      <React.Fragment>
        {/* <div><p>Session ID: {browserSessionID}</p>    </div> */}
        <SideMenuContext.Consumer>
          {({ isSelectedMenu, activeTabData }) => {
            // let fieldData =
            //   isSelectedMenu?.fieldData?.length > 0
            //     ? JSON.parse(
            //         isSelectedMenu?.fieldData
            //           ?.replace(/`/g, '"') // Replace backticks with double quotes
            //           ?.replace(/(\w+):/g, '"$1":') ?? // Wrap unquoted keys with double quotes
            //           ""
            //       )
            //     : [];

            // if (fieldData.length > 0) {
            //   fieldData = fieldData.map((field) => {
            //     return {
            //       ...field,
            //       ...(field?.id === 3 && {
            //         value:
            //           this.props.registrationNumber
            //             ?.replace(/\//g, "\\")
            //             ?.split("\\")
            //             .join("/") || "",
            //       }),
            //     };
            //   });
            // }

            if (this.props.processName && activeTabData) {
              activeTabData = activeTabData.map((item) => {
                if (item.itemId === 8) {
                  return {
                    ...item,
                    value: this.props.processName,
                  };
                }
                return item;
              });
            }

            const fieldData = activeTabData?.map((tData) => {
              return {
                ...tData,
                name: tData?.["id"],
                label: tData?.["title"],
                type: `text`,
                placeholder: ``,
                readonly: true,
                value: tData?.["value"] || ``,
              };
            });
            if (this.state.activeTabData !== activeTabData) {
              this.updateTimeout = setTimeout(() => {
                if (this._isMounted) {
                  this.setState({ activeTabData });
                }
              }, 0);
            }

            return (
              <div id="TamarLoad">
                <form onSubmit={this.handleSubmit} className="SearchTamarForm">
                  <div
                    id="ErrorMessageDiv"
                    className="ErrorMessageDivMarginleft"
                  >
                    {errorMessage}
                  </div>

                  <div className="column-right">
                    <DynamicForm
                      formFields={
                        fieldData
                        // fieldData?.length ? sideMenuContext.activeTabData : formFields
                      }
                    />
                    <div className="attachedFileChecksWrapper">
                      <div onChange={this.onChangeValue} className="radio-col">
                        <label>
                          בדיקות אוטומטיות מלאות
                          <input
                            className="smallInput"
                            type="radio"
                            value="D2_D3_ALL"
                            name="ChecksToRun"
                            defaultChecked
                            disabled={this.props.isDisabled}
                          />
                        </label>
                        <label>
                          בדיקות מבוקרות בשלבים
                          <input
                            className="smallInput"
                            type="radio"
                            value="D2_ALL"
                            name="ChecksToRun"
                            disabled={this.props.isDisabled}
                          />
                        </label>
                        <label>
                          <button id="invisibleButton"></button>
                          <div className="ellipsis-button-container">
                            <button
                              type="button"
                              className={
                                rb12s?.includes(selectedRuns) ||
                                this.props.isDisabled
                                  ? "btnDissabled smallBrowseButton cursor-disabled"
                                  : "smallBrowseButton"
                              }
                              onClick={this.togglePopup}
                              disabled={
                                rb12s?.includes(selectedRuns) ||
                                this.props.isDisabled
                              }
                            >
                              ...
                            </button>
                            {isPopupOpen && (
                              <ChecksPopupForm
                                isFirstLoad={this.state.isFirstLoad}
                                id="ChecksPopupForm"
                                closePopup={this.togglePopup}
                                D2_checksList={D2_checksList}
                                D3_advanced={D3_advanced}
                                D3_cmp={D3_cmp}
                                onSelectedCheckboxesChange={
                                  this.handleSelectedCheckboxes
                                }
                              />
                            )}
                          </div>
                          בדיקות לפי בחירה
                          <input
                            className="smallInput"
                            type="radio"
                            value="ChosenRuns"
                            name="ChecksToRun"
                            disabled={this.props.isDisabled}
                          />
                        </label>
                      </div>

                      <div className="row">
                        <input
                          className=""
                          type="file"
                          onChange={this.handleFileChange}
                          id="file-input"
                          disabled={this.props.isDisabled}
                          readOnly={this.props.isDisabled}
                        />
                        <button
                          type="button"
                          className={
                            this.props.isDisabled
                              ? "btnDissabled browseButton"
                              : "browseButton"
                          }
                          disabled={this.props.isDisabled}
                          onClick={() =>
                            document.getElementById("file-input").click()
                          }
                        >
                          ...
                        </button>
                        {selectedFile && <div></div>}

                        {loadingFile ? (
                          <button
                            type="button"
                            className={
                              "btnDissabled start-button cursor-disabled"
                            }
                            // className={
                            //   this.props.isDisabled
                            //     ? "btnDissabled start-button cursor-disabled"
                            //     : "start-button"
                            // }
                            disabled={this.props.isDisabled}
                          >
                            <div className="fileLoading">
                              <img src={loadingIcon} alt="loading" />
                            </div>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={
                              this.props.isDisabled
                                ? "btnDissabled start-button cursor-disabled"
                                : "start-button"
                            }
                            onClick={
                              rb12s?.includes(selectedRuns)
                                ? this.getFileIsExistOrNot
                                : this.handleStartRun
                            }
                            disabled={this.props.isDisabled}
                          >
                            התחלת בדיקות
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            );
          }}
        </SideMenuContext.Consumer>
        <ModalComponent
          show={this.state.fileIsExists}
          onHide={() => {
            this.processOverrideOrNot(false);
          }}
          title=""
          bodyContent={
            <p>?התמ”ר קיימת בבסיס הנתונים. האם תרצה להמשיך ולדרוס אותה</p>
          }
          footerContent={
            <>
              <Button
                onClick={() => {
                  this.processOverrideOrNot(false);
                }}
              >
                לא
              </Button>
              <Button
                onClick={() => {
                  this.processOverrideOrNot(true);
                }}
              >
                כן
              </Button>
            </>
          }
        />
        {/* <ModalComponent
          show={this.state.processNoIsNotFound}
          onHide={() => this.setState({ processNoIsNotFound: false })}
          title=""
          bodyContent={<p>תהליך מס' לא נמצא</p>}
          footerContent={
            <Button
              onClick={() => {
                this.setState({ processNoIsNotFound: false });
                this.props.isDataInProcess(false);
              }}>
              לִסְגוֹר
            </Button>
          }
        /> */}
        <ModalComponent
          show={this.state.somethingWentToWrong}
          onHide={() => {
            this.setState({ somethingWentToWrong: false });
            this.props.isDataInProcess(false);
          }}
          title=""
          bodyContent={<p>{errorValidateProcessMessage}</p>}
          footerContent={
            <Button
              onClick={() => {
                this.setState({ somethingWentToWrong: false });
                this.props.isDataInProcess(false);
              }}
            >
              סגירה
            </Button>
          }
        />
        <ModalComponent
          show={this.state.noCheckChosen}
          onHide={() => {
            this.setState({ noCheckChosen: false });
          }}
          title=""
          bodyContent={<p>לא נבחרו בדיקות להרצה</p>}
          footerContent={
            <Button
              onClick={() => {
                this.setState({ noCheckChosen: false });
              }}
            >
              סגירה
            </Button>
          }
        />
        <ModalComponent
          show={this.state.D4IsDone}
          onHide={() => this.setState({ D4IsDone: false })}
          title=""
          bodyContent={<p>{D4ResultMessage}</p>}
          footerContent={
            <>
              <Button
                onClick={() => {
                  this.setState({ D4IsDone: false });
                }}
              >
                סגירה
              </Button>
            </>
          }
        />
        {/* is file not selected alert */}

        <ModalComponent
          show={this.state.isFileSelectedForstartRun}
          onHide={() => {
            this.setState({ isFileSelectedForstartRun: false });
          }}
          title=""
          bodyContent={<p dir="rtl">אנא בחר קובץ לפני שתמשיך.</p>}
          footerContent={
            <>
              <Button
                onClick={() => {
                  this.setState({ isFileSelectedForstartRun: false });
                }}
              >
                בְּסֵדֶר
              </Button>
            </>
          }
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  projectData: state?.project?.NewProject,
  loading: state?.project?.status,
  error: state?.project?.error,
});

// Map dispatch to props
const mapDispatchToProps = {
  clearAllErrors,
  setErrorMessage,
  setIsSuccessUpdate,
  setSuccessMessage,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(SearchTamarForm);
